module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "confirm-modal",
    attrs: {
      "visible": _vm.show,
      "before-close": _vm.cancel,
      "close-on-click-modal": false
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确 定")]), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取 消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e125a62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Confirm.vue
// module id = 1050
// module chunks = 1